import axios from 'axios';
import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';

const { CancelToken } = axios;

let fetchChecklistExport_cancel;

export const fetchEquipmentServicesSuccess = (equipmentServices) => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_SERVICES_SUCCESS,
    equipmentServices: equipmentServices
  };
};

export const fetchSelectedEquipmentMassServicesSuccess = (selectedEquipmentMassServices) => {
  return {
    type: actionTypes.FETCH_SELECTED_EQUIPMENT_MASS_SERVICES_SUCCESS,
    selectedEquipmentMassServices: selectedEquipmentMassServices
  };
};

export const requestEquipmentServicesFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_SERVICES_FAIL,
    error: error
  };
};

export const requestSelectedEquipmentMassServicesFail = (error) => {
  return {
    type: actionTypes.REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_FAIL,
    error: error
  };
};

export const requestEquipmentServicesStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_SERVICES_START
  };
};

export const requestSelectedEquipmentMassServicesStart = () => {
  return {
    type: actionTypes.REQUEST_SELECTED_EQUIPMENT_MASS_SERVICES_START
  };
};

export const deleteEquipmentServicesSuccess = (equipmentServices) => {
  return {
    type: actionTypes.DELETE_EQUIPMENT_SERVICES_SUCCESS,
    equipmentServices: equipmentServices
  }
}

export const checkDeleteEquipmentServicesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_EQUIPMENT_SERVICES_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateEquipmentServicesSuccess = (equipmentServices) => {
  return {
    type: actionTypes.UPDATE_EQUIPMENT_SERVICES_SUCCESS,
    equipmentServices: equipmentServices
  }
}

export const postEquipmentServicesSuccess = (equipmentServices) => {
  return {
    type: actionTypes.POST_EQUIPMENT_SERVICES_SUCCESS,
    equipmentServices: equipmentServices
  }
}

export const hardDeleteEquipmentServicesSuccess = () => {
  return {
    type: actionTypes.HARD_DELETE_EQUIPMENT_SERVICES_SUCCESS,
  }
}

export const postMassServicesSuccess = () => {
  return {
    type: actionTypes.POST_MASS_SERVICE_SUCCESS
  }
}

export const requestMassServicesFail = () => {
  return {
    type: actionTypes.REQUEST_MASS_SERVICES_FAIL
  }
}

export const fetchEquipmentServices = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestEquipmentServicesStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/equipmentservices' + queryParams)
      .then(res => {
        dispatch(fetchEquipmentServicesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentServicesFail(err));
      });
  };
};

export const deleteEquipmentServices = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentServicesStart());
      API.put('/equipmentservices/' + index + '/delete')
        .then(res => {
          dispatch(deleteEquipmentServicesSuccess(res.data));
          toastr.success(i18n.t('deleteEquipmentServices.toastr'))
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const checkDeleteEquipmentServices = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentServicesStart());
      API.get('/equipmentservices/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteEquipmentServicesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentServicesFail(err));
          resolve('error');
        });
    })
  }
}

export const postEquipmentServices = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentServicesStart());
      API.post('/equipmentservices', body)
        .then(res => {
          dispatch(postEquipmentServicesSuccess(res.data));
          toastr.success(i18n.t('postEquipmentServices.toastr'))
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentServicesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postEquipmentServices.toastrError'), i18n.t('postEquipmentServices.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateEquipmentServices = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentServicesStart());
      API.put('/equipmentservices/' + index, body)
        .then(res => {
          dispatch(updateEquipmentServicesSuccess(res.data));
          toastr.success(i18n.t('updateEquipmentServices.toastr'))
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentServicesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateEquipmentServices.toastrError'), i18n.t('updateEquipmentServices.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const hardDeleteEquipmentServices = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentServicesStart());
      API.delete('/equipmentservices/' + index)
        .then(res => {
          dispatch(hardDeleteEquipmentServicesSuccess());
          toastr.success(i18n.t('hardDeleteEquipmentServices.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const fetchChecklistExport = (equipmentId, equipmentServiceId, emailLanguage) => {
  fetchChecklistExport_cancel && fetchChecklistExport_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      const languageParams = `${emailLanguage && emailLanguage.length > 0 ? `?emailLanguage=${emailLanguage}` : '?emailLanguage=pt'}`;

      API.get(`/equipmentservices/${equipmentId}/${equipmentServiceId}/checklistexport` + languageParams, {
        cancelToken: new CancelToken(((c) => {
          fetchChecklistExport_cancel = c;
        }))
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        toastr.error('Erro', err.response.data.message)
        reject(err);
      })
    })
  }
}

export const fetchSelectedEquipmentMassServices = (equipmentModel) => {
  return dispatch => {
    dispatch(requestSelectedEquipmentMassServicesStart());
    API.get(`/equipmentservices/selectedmassservices?equipmentModel=${equipmentModel}`)
      .then(res => {
        dispatch(fetchSelectedEquipmentMassServicesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestSelectedEquipmentMassServicesFail(err));
      });
  };
};

export const postMassService = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestSelectedEquipmentMassServicesStart());
      API.post('/services/massservice', body)
        .then(res => {
          dispatch(postMassServicesSuccess(res.data));
          toastr.success(`${i18n.t('postEquipmentServices.massService')} (${body.equipments.length})`)
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestMassServicesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

const inactivateEquipmentServiceStart = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_INACTIVATE_START,
  }
}

const inactivateEquipmentServiceSucess = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_INACTIVATE_SUCCESS,
  }
}

const inactivateEquipmentServiceFail = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_INACTIVATE_FAIL,
  }
}

export const inactivateEquipmentService = (equipmentServiceId, equipmentModelId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(inactivateEquipmentServiceStart());
      API.put(`/equipmentservices/inactivate/${equipmentServiceId}/${equipmentModelId}`)
        .then(res => {
          dispatch(inactivateEquipmentServiceSucess());
          toastr.success(i18n.t('storeEquipmentService.inactivateSuccess'))
          resolve('success');
        })
        .catch(err => {
          dispatch(inactivateEquipmentServiceFail(err));
          toastr.error('Erro', i18n.t('storeEquipmentService.inactivateError'));
          console.log(err);
          resolve('error');
        });
    })
  }
}

const activateEquipmentServiceStart = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_ACTIVATE_START,
  }
}

const activateEquipmentServiceSucess = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_ACTIVATE_SUCCESS,
  }
}

const activateEquipmentServiceFail = () => {
  return {
    type: actionTypes.EQUIPMENT_SERVICES_ACTIVATE_FAIL,
  }
}

export const activateEquipmentService = (equipmentServiceId, equipmentModelId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(activateEquipmentServiceStart());
      API.put(`/equipmentservices/activate/${equipmentServiceId}/${equipmentModelId}`)
        .then(res => {
          dispatch(activateEquipmentServiceSucess());
          toastr.success(i18n.t('storeEquipmentService.activateSuccess'))
          resolve('success');
        })
        .catch(err => {
          dispatch(activateEquipmentServiceFail(err));
          toastr.error('Erro', i18n.t('storeEquipmentService.activateError'));
          console.log(err);
          resolve('error');
        });
    })
  }
}